import { businessUsersActions } from './businessUsersSlice'
import { fetchCachedHelper, fetchHelper } from '../../../api/api'
import { getErrorMessage } from '../../../util/functions'

export const getBusinessBeneficiaries = email => async dispatch => {
    dispatch(businessUsersActions.getUsersRequest())
    try {
        const response = await fetchHelper(
            `Beneficiary/OwnerBeneficiaries/${email}`
        )
        dispatch(businessUsersActions.getUsersRequestSuccess(response.data))
    } catch (e) {
        dispatch(businessUsersActions.getUsersRequestError(e.message))
    }
}

export const inviteBeneficiary = ({ email, addedby }) => async dispatch => {
    dispatch(businessUsersActions.inviteUsersRequest())
    try {
        await fetchHelper.post(`Beneficiary/Invite/${email}/1/${addedby}`)
        dispatch(businessUsersActions.inviteUsersRequestSuccess())
    } catch (e) {
        dispatch(
            businessUsersActions.inviteUsersRequestError(getErrorMessage(e))
        )
    }
}

export const deleteBeneficiary = email => async dispatch => {
    dispatch(businessUsersActions.deleteUserRequest())
    try {
        await fetchHelper.delete(`Beneficiary/${email}`)
        dispatch(businessUsersActions.deleteUserRequestSuccess())
    } catch (e) {
        dispatch(
            businessUsersActions.deleteUserRequestError(
                getErrorMessage(e.message)
            )
        )
    }
}
